import { render, staticRenderFns } from "./SearchDialog.vue?vue&type=template&id=cd610e70&scoped=true"
import script from "./SearchDialog.vue?vue&type=script&lang=js"
export * from "./SearchDialog.vue?vue&type=script&lang=js"
import style0 from "./SearchDialog.vue?vue&type=style&index=0&id=cd610e70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd610e70",
  null
  
)

export default component.exports